<template>
  <section class="py-3 bg-black w-full sticky top-0 z-40">
    <div class="max-w-screen-2lg mx-auto px-4 flex flex-wrap">
      <button
        type="button"
        class="scroll-to text-white font-semibold text-md md:text-lg text-center md:w-1/3 w-full pb-3 mb-3 border-b border-bottom md:border-0 md:pb-0 md:mb-0"
        @click="scrollToSection('overview')"
      >
        Overview
      </button>

      <button
        type="button"
        class="scroll-to text-white font-semibold text-md md:text-lg text-center md:w-1/3 w-full"
        @click="scrollToSection('daylist')"
      >
        Trip Details
      </button>

      <button
        type="button"
        class="scroll-to text-white font-semibold text-md md:text-lg text-center md:w-1/3 w-full"
        @click="scrollToSection('pricing')"
      >
        Pricing
      </button>
    </div>
  </section>
</template>

<script>
export default {
  name: "NavBar",
  methods: {
    scrollToSection(id) {
      const el = document.getElementById(id);
      if (!el) return;
      el.scrollIntoView({ behavior: "smooth", block: "start" });
    },
  },
};
</script>
